<template>
  <div
    class="modal theme-modal fade show"
    style="display: block; padding-right: 15px;"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="border modal-content">
        <div class="top-0 z-1 position-absolute me-3 mt-3 end-0">
          <button
            class="d-flex flex-center transition-base btn-close btn btn-sm btn-circle"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleClose"
          />
        </div>

        <div class="bg-body-tertiary py-3 ps-4 pe-6 rounded-top-3">
          <h4
            id="staticBackdropLabel"
            class="mb-1"
          >
            고객 등록/수정
          </h4>
          <p
            v-if="isRegMode"
            class="mb-0 fs-11"
          >
            고객코드 : <a
              class="link-600 fw-semi-bold"
              href="#!"
            >{{ form.clientcode }}</a>
          </p>
        </div>

        <div class="px-card pt-1 pb-card modal-body fs--1">
          <div class="mt-3 media">
            <div class="media-body">
              <div class="text-800 fs--1">
                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    고객코드
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="form.clientcode"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                    :disabled="!isRegMode"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    고객 이름
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="form.clientname"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    서비스 상태
                  </h6>
                  <select
                    v-model="form.servicestate"
                    class="me-2 form-select-sm select-month form-select"
                    style="width:100%; display:inline;"
                  >
                    <option
                      v-for="sstatus in serviceStatusList"
                      :key="sstatus.scode"
                      :value="sstatus.scode"
                    >
                      {{ sstatus.status }}
                    </option>
                  </select>
                </div>

                <div
                  v-if="!isRegMode"
                  class="d-flex align-items-center modal_div"
                >
                  <h6 class="me-2 mb-0 device-title">
                    비밀번호 변경
                  </h6>
                  <input 
                    v-model="checkPassword" 
                    class="form-check-input" 
                    type="checkbox"
                    :true-value="1"
                    :false-value="0"
                  >
                </div>

                <div
                  v-if="showPasswordInput"
                  class="d-flex align-items-center modal_div"
                >
                  <h6 class="me-2 mb-0 device-title">
                    비밀번호
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="form.password"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>
                
                <div
                  v-if="showPasswordInput"
                  class="d-flex align-items-center modal_div"
                >
                  <h6 class="me-2 mb-0 device-title">
                    비밀번호 확인
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="form.passwordcheck"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleSave"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />저장
          </a>
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleClose"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />취소
          </a>
        </div>
      </div>
    </div>
  </div>

   

  <AlertModal ref="alertModalRef" />
</template>

<script setup lang="ts">

import type { Client, ServiceStatus } from '@/types/commontypes'
import { onMounted, defineProps, ref, computed, watch} from 'vue';
import AlertModal from "@/components/AlertModal.vue";

const emit = defineEmits(['ClientClose', 'ClientSave'])

const props = defineProps<{
    setclient: Client | null;
    isRegMode: boolean;
}>();

const form = ref( {
    clientcode: '',
    clientname: '',
    clientlevel: 0,
    servicestate: 0,
    regdt: '',
    password: '',
    passwordcheck: ''
})

const checkPassword = ref(0)
const serviceStatusList = ref<ServiceStatus[]>([])

const alertModalRef = ref();

watch(() => props.setclient, 
    (newval) => {
        if(newval) {
            // formatClient.value = {...newval}
            form.value = {
                clientcode: newval.clientcode,
                clientname: newval.clientname,
                clientlevel: newval.clientlevel,
                servicestate: newval.servicestate,
                regdt: '',
                password: '',
                passwordcheck: ''
            }
        } else {
            // formatClient.value = {...defaultClient}    
                form.value = {
                    clientcode: '',
                    clientname: '',
                    clientlevel: 0,
                    servicestate: 0,
                    regdt: '',
                    password: '',
                    passwordcheck: ''
                }
        }
    },
    { immediate: true, deep: true }
)

const showPasswordInput = computed(() => {
    return props.isRegMode || checkPassword.value
})


onMounted(async () =>{
      serviceStatusList.value= [
        {scode:0, status:'정상'},
        {scode:1, status:'잠김'},
      ]
});

function handleSave() {
    if(!form.value.clientcode) {
        alertModalRef.value.showAlertModal("경고", "고객코드를 입력해 주세요.");
        return;
    }

    if(!form.value.clientname) {
        alertModalRef.value.showAlertModal("경고", "고객 이름을 입력해 주세요.");
        return;
    }


    let data;
    if(props.isRegMode) {
        // 등록모드
        data = { 'operator': "setClient", 
                "clientcode":form.value.clientcode, 
                'clientname' : form.value.clientname, 
                'password' : form.value.password, 
                "servicestate": form.value.servicestate 
              }  
    } else {
        // 수정모드
        data = { 'operator': "updateClient", 
                "clientcode":form.value.clientcode, 
                'clientname' : form.value.clientname, 
                'password' : form.value.password, 
                "servicestate": form.value.servicestate 
              }
    }

    const data2 = JSON.stringify(data)
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ajax/ajaxcall');
    xhr.setRequestHeader('Content-type', "application/json");
    xhr.send(data2);

    // 데이터 수신이 완료되면 표시
    xhr.addEventListener('load', () => {
          const result = xhr.responseText;
          const retJSON = JSON.parse(result);
          if(retJSON.err == 0) {
              emit('ClientSave');
          } else {
              console.log("failed! ", retJSON.err);
              alertModalRef.value.showAlertModal("경고", `등록/수정이 실패 했습니다. ${retJSON.err}`);
          }
      });
}

function handleClose() {
    emit('ClientClose')
}

</script>

<style lang="">
    
</style>